import { render, staticRenderFns } from "./CircularLayout.vue?vue&type=template&id=ef4db198&scoped=true&"
import script from "./CircularLayout.vue?vue&type=script&lang=js&"
export * from "./CircularLayout.vue?vue&type=script&lang=js&"
import style0 from "./CircularLayout.vue?vue&type=style&index=0&id=ef4db198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4db198",
  null
  
)

/* custom blocks */
import block0 from "./CircularLayout.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports